import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { ArrowRight, Leaf, TrendingUp, Shield } from 'lucide-react';

const Home = () => {
  return (
    <div className="min-h-screen">
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1560409065-edc62644e72d?crop=entropy&cs=srgb&fm=jpg&q=85)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'grayscale(50%)'
          }}
        >
          <div className="absolute inset-0 bg-black/80" />
        </div>

        <div className="hero-glow absolute inset-0 z-0" />

        <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-24 py-32 md:py-48">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl"
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold tracking-tight mb-6 leading-tight">
              Negocie Créditos de Carbono
              <br />
              <span className="text-primary">Com Transparência</span>
            </h1>
            <p className="text-lg text-zinc-400 mb-8 max-w-2xl">
              Compre e venda créditos de carbono no marketplace. Negocie créditos de carbono verificados.
            </p>
            <p className="text-lg text-zinc-600 mb-8 max-w-2xl">
              * Créditos para fins da lei 15.042/24
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/marketplace" data-testid="hero-explore-marketplace">
                <Button className="bg-primary text-black hover:bg-[#B3E600] hover:shadow-[0_0_20px_rgba(204,255,0,0.3)] rounded-sm font-medium tracking-wide transition-all duration-200 h-12 px-8">
                  Explorar Marketplace
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
              <Link to="/auth" data-testid="hero-start-selling">
                <Button className="border border-[#333] bg-transparent text-white hover:border-primary hover:text-primary rounded-sm font-medium tracking-wide transition-all duration-200 h-12 px-8">
                  Começar a Vender
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6 md:px-12 lg:px-24">
        <div className="container mx-auto">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-12 text-center">
              Por Que Escolher a MeJ?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                className="bg-card border border-border rounded-sm p-8 hover:border-primary/50 transition-colors duration-300"
                data-testid="feature-verified"
              >
                <Shield className="w-12 h-12 text-primary mb-4" strokeWidth={1.5} />
                <h3 className="text-xl font-heading font-bold mb-3">Créditos Verificados</h3>
                <p className="text-zinc-400">
                  Todos os créditos são respaldados por documentação verificada e reservas legais.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                className="bg-card border border-border rounded-sm p-8 hover:border-primary/50 transition-colors duration-300"
                data-testid="feature-transparent"
              >
                <TrendingUp className="w-12 h-12 text-primary mb-4" strokeWidth={1.5} />
                <h3 className="text-xl font-heading font-bold mb-3">Negociação Transparente</h3>
                <p className="text-zinc-400">
                  Navegue por ofertas, conecte-se com vendedores e negocie diretamente.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                className="bg-card border border-border rounded-sm p-8 hover:border-primary/50 transition-colors duration-300"
                data-testid="feature-impact"
              >
                <Leaf className="w-12 h-12 text-primary mb-4" strokeWidth={1.5} />
                <h3 className="text-xl font-heading font-bold mb-3">Impacto Real</h3>
                <p className="text-zinc-400">
                  Apoie projetos de reflorestamento e ajude a preservar reservas legais.
                </p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;
